package com.patronat.top.features.usermanagement.domain.models

import com.patronat.top.core.domain.models.profiles.User

data class FilteredUsers(
    val items: List<User>,
    val totalCount: Long,
    val page: Int,
    val pageSize: Int
)